export const featureRowDataHooks = {
  voucherDisclaimer: 'voucher-disclaimer',
  truncatedDomainName: 'truncated-domain-name',
  name: 'feature-name',
  newBadge: 'feature-new-badge',
  benefit: 'feature-benefit',
  description: 'feature-description',
  tooltip: 'feature-tooltip',
  vIcon: (index: number) => `v-icon-${index}`,
  xIcon: (index: number) => `x-icon-${index}`,
  groupIcon: 'feature-group-icon',
  group: 'feature-group',
};
